/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for anypurpose without the express written permission of Honeywell. */
import { Button } from "@mui/material";
import React from "react";
import "./Buttons.scss";

/**
 * Reusable buttons
 */

interface IProps {
  btnText: string;
  style?: any;
  onClick: () => void;
}

export const PrimaryBtn = (props: IProps) => {
  return (
    <Button
      variant="contained"
      className="primary-btn"
      style={props.style}
      onClick={() => props.onClick()}
    >
      {props.btnText}
    </Button>
  );
};

export const TextBtn = (props: IProps) => {
  return (
    <Button variant="text" className="text-btn" onClick={() => props.onClick()}>
      {props.btnText}
    </Button>
  );
};

export const OutlinedBtn = (props: IProps) => {
  return (
    <Button
      variant="outlined"
      className="text-btn"
      onClick={() => props.onClick()}
    >
      {props.btnText}
    </Button>
  );
};
